module.exports = __webpack_public_path__ + "img/icon_analitica.e2d49033.svg";